import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const processStepSlice = createSlice({
    name: 'processStep',
    initialState,
    reducers: {
        funGetProcessStep(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( processStep ) => {
                return{
                    ...processStep,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const processStepActions = processStepSlice.actions;
export default processStepSlice.reducer;